import { render, staticRenderFns } from "./spDetail.vue?vue&type=template&id=40439b97"
import script from "./spDetail.vue?vue&type=script&lang=js"
export * from "./spDetail.vue?vue&type=script&lang=js"
import style0 from "./spDetail.vue?vue&type=style&index=0&id=40439b97&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports